import SortableView from "backbone/shared/views/sortable_view.js"

$selectors =
  step: ".js-step"
  totalPrice: ".js-total-price"
  workerPrice: ".js-worker-price"
  payment: ".js-add-payment"
  eligibleField: ".js-step-eligible-to"
  remoteToggle: ".js-off-platform-toggle"
  standardToggle: ".js-standard-step-toggle"
  typeToggles: ".js-step-type"
  remoteApproverRow: ".js-remote-approver-row"
  durationDays: ".js-duration-days"
  completionTime: ".js-completion-time"
  completionTimeError: ".js-time-error"
  manageTaskInDropdown: "select.js-manage-task-in"
  manageTaskRemoteLabel: "label.js-manage-remote"
  manageTaskLocalLabel: "label.js-manage-local"
  continueButton: ".js-continue-button"

export default class ApprovalFlowFormView extends SortableView
  events:
    "nested:fieldAdded:story_approval_steps"        : "onStepAdded"
    "nested:fieldRemoved:story_approval_steps"      : "onStepRemoved"
    "nested:fieldAdded:steps"                       : "onStepAdded"
    "nested:fieldRemoved:steps"                     : "onStepRemoved"
    "nested:fieldAdded:remote_approval_templates"   : "onRemoteApproverAdded"
    "nested:fieldRemoved:remote_approval_templates" : "onRemoteApproverRemoved"
    "sortstop"                                      : "onSortStop"
    "click #submit-approval-flow"                   : "onSaveValidation"
    "click .js-continue-button"                     : "onSaveValidation"

  initialize: ->
    super
    _.extend(@events, SortableView.prototype.events)
    @$form = @$el
    contently.ui.setup_time_inputs(@$form)
    @setupStepValidationsAndDisplay()
    @setupManageTaskInDropdowns()

  setupStepValidationsAndDisplay: ->
    for stepWithTypes in $($selectors.typeToggles)
      @setupStepTypeDisplay($(stepWithTypes).parents($selectors.step))

  setupRemoteStepDisplay: ($step) ->
    $remoteApprover = $step.find($selectors.remoteApproverRow)
    $remoteApprover.find(".js-destroy-remote-approval").find("input").val("0")
    $remoteApproversSelect = $remoteApprover.find("select")
    $remoteApprover.show()

  removeRemoteStepDisplay: ($step) ->
    $remoteApprover = $step.find($selectors.remoteApproverRow)
    $remoteApprover.hide()
    $remoteApproversSelect = $remoteApprover.find("select")
    $remoteApproversSelect.val("")
    $remoteApprover.find(".js-destroy-remote-approval").find("input").val("1")

  _eligibleToType: ($eligibleToSelect) ->
    @_eligibleToValues($eligibleToSelect)[0]

  _eligibleToId: ($eligibleToSelect) ->
    @_eligibleToValues($eligibleToSelect)[1]

  _eligibleToValues: ($eligibleToSelect) ->
    $eligibleToSelect.val().split("::")

  _eligibleToTeam: ($eligibleToSelect) ->
    @_eligibleToType($eligibleToSelect) == "Team"

  _eligibleToUser: ($eligibleToSelect) ->
    @_eligibleToType($eligibleToSelect) == "User"

  onStepAdded: (event) ->
    $step = event.field
    contently.ui.setup_select2($step)
    contently.ui.setup_time_inputs($step)
    @setupStepTypeDisplay($step)
    @setupManageTaskInDropdowns($step)
    @_handleParsleyFields(event, "addItem")

  onStepRemoved: (event) ->
    @_handleParsleyFields(event, "removeItem")

  setupStepTypeDisplay: ($step) ->
    manageInValue = $step.find($selectors.manageTaskInDropdown).val()
    $manageTaskRemoteLabel = $step.find($selectors.manageTaskRemoteLabel)
    $manageTaskLocalLabel = $step.find($selectors.manageTaskLocalLabel)
    if manageInValue == "contently"
      $manageTaskLocalLabel.show()
      $manageTaskRemoteLabel.hide()
      @removeRemoteStepDisplay($step)
    else
      $manageTaskLocalLabel.hide()
      $manageTaskRemoteLabel.show()
      @setupRemoteStepDisplay($step)

  ##
  # Append a tooltip to the Select2 display if it has a tooltipText data added to it.
  # The tooltips are generated on the Ruby side in WorkflowsHelper manage_task_in_options().
  addTooltip: (data) ->
    if (!data.loading)
      tooltip = if data.element.dataset.tooltipText then $('<span class="icon icon-question-circle" data-behavior="tooltip" data-tooltip-text="' + data.element.dataset.tooltipText + '" />') else $('<span />')
      $('<span class="manage-task-in-option">'+data.text+'</span>').append(tooltip)

  ##
  # Set up the "Manage Task In" dropdowns
  # Rails outputs a basic HTML select dropdown; this turns that into a fancy JavaScript
  # dropdown using the Select2 library.
  setupManageTaskInDropdowns: ->
    overrides =
      selectOnClose: true,
      templateResult: @addTooltip
      templateSelection: @addTooltip

    select2Opts = $.extend(
      {},
      contently.ui.select2defaults,
      overrides
    )
    manageTasksSelects = $($selectors.manageTaskInDropdown)

    if manageTasksSelects.exists()
      manageTasksSelects.select2(select2Opts)
      manageTasksSelects.off('select2:select')
      manageTasksSelects.on('select2:select', @onManageTaskInSelection)

  ##
  # Handler callback for when the Manage Task In dropdown changes
  onManageTaskInSelection: (e) =>
    $step = $(e.target).parents($selectors.step)
    @setupStepTypeDisplay($step)

  onRemoteApproverAdded: (event) ->
    $remoteApprover = event.field
    contently.ui.setup_select2($remoteApprover)

  onRemoteApproverRemoved: (event) ->
    $remoteApprover = event.field
    $remoteApproversSelect = $remoteApprover.find("select")
    $remoteApproversSelect.removeAttr("required")
    $remoteApprover.detach().appendTo(@$form)

  onSortStop: (e, ui) ->
    super
    @_setFirstStepToStandard()

  onSaveValidation: (event) ->
    durationDays = $($selectors.durationDays)
    completionTime = $($selectors.completionTime)
    completionTimeError = $($selectors.completionTimeError)
    if completionTime.val() && !durationDays.val()
      event.preventDefault()
      completionTime.css('border-color', 'red')
      completionTimeError
        .html("You cannot add a time without a duration.")
        .css("font-size", "12px")
        .css("color", "red")
      return false

  _setFirstStepToStandard: ->
    if $($selectors.typeToggles).length > 0
      $($selectors.step).first().find($selectors.standardToggle).click()

  _handleParsleyFields: (event, action) ->
    $step = event.field
    $title = $step.find(".js-step-title")
    $eligibleSelect = $step.find($selectors.eligibleField)
    $totalPrice = $step.find(".js-total-price")
    $workerPrice = $step.find(".js-worker-price")
    $remoteApprover = $step.find(".js-remote-approver-row").find("select")

    for input in [$title, $eligibleSelect, $totalPrice, $workerPrice, $remoteApprover]
      continue if input.length == 0

    switch action
      when "addItem"
        $title.prop("required", true)
        $eligibleSelect.select2
          minimumResultsForSearch: 10
      when "removeItem"
        $step.detach().appendTo(@$form)
        $title.removeAttr("required")
        $remoteApprover.removeAttr("required")



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/approval_flow_form_view.js.coffee